export enum SaleTypeFilter {
  All,
  BuyItNow,
  TimedAuction,
  ManagedSale,
  Underwrite
}
